import { type TranslationTree } from '@/i18n/types';

export const messages = {
  label: 'Seções do portal',
  items: {
    events: 'Eventos',
    offers: 'Ofertas',
    results: 'Resultados',
    links: 'Links',
    integration: 'Integração',
    account: 'Conta',
  },
} satisfies TranslationTree;
